import React from 'react';

import { ButtonGroup } from '@atlaskit/button';

const ModalButtons = ({ children }) => (
  <div style={{ paddingTop: 24, paddingBottom: 24, display: 'flex', justifyContent: 'flex-end' }}>
    <ButtonGroup>
      {children}
    </ButtonGroup>
  </div>
);

export default ModalButtons;
